module.exports = __webpack_public_path__ + "img/3600.641bc53b.jpg";